interface Pipeline {
    handleScrollX?: (e: Event) => void
}

interface ScrollXPipelineParams {
    pipeline: Pipeline
    onScrollX?: (isScrolling: boolean) => void
}

const TIME_OUT = 200

const scrollXPipeline = ({ pipeline, onScrollX }: ScrollXPipelineParams): Pipeline => {
    let scrollTimeoutId: ReturnType<typeof setTimeout> | null = null
    let isScrolling = false

    const handleScrollX = (e: Event) => {
        const target = e.currentTarget as HTMLElement
        if (!target) return

        const { scrollLeft, clientWidth, scrollWidth } = target

        // 是否发生水平滚动
        const isHorizontal = scrollLeft > 0 && scrollWidth > clientWidth
        if (!isHorizontal) return

        // 只在滚动开始时触发 `true`
        if (!isScrolling) {
            isScrolling = true
            onScrollX?.(true)
        }

        // 如果之前的定时器存在，清除它
        if (scrollTimeoutId) {
            clearTimeout(scrollTimeoutId)
        }

        // 设置一个定时器，确保滚动停止后触发 `false`
        scrollTimeoutId = setTimeout(() => {
            isScrolling = false
            onScrollX?.(false)
        }, TIME_OUT) // TIME_OUT ms 内无滚动才触发 false
    }

    pipeline.handleScrollX = handleScrollX
    return pipeline
}

export default scrollXPipeline
